import { DocumentSnapshot, QueryConstraint } from 'firebase/firestore';

export interface PaginationOptions {
  limit?: number;
  startAfter?: DocumentSnapshot;
  startBefore?: DocumentSnapshot;
}

export interface PaginatedResult<T> {
  data: T[];
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  nextPageCursor?: DocumentSnapshot;
  previousPageCursor?: DocumentSnapshot;
  totalCount?: number;
}

export interface PaginationState {
  currentPage: number;
  pageSize: number;
  cursors: (DocumentSnapshot | null)[];
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export type PaginationConstraints = QueryConstraint[];

// Default page size - balance between cost and UX
export const DEFAULT_PAGE_SIZE = 25;

// Maximum allowed page size to prevent excessive data transfer
export const MAX_PAGE_SIZE = 100;